<template>
  <div class="equipment-list">
    <div class="search-form">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        @submit.native.prevent
      >
        <div class="search-row">
          <div class="search-conent">
            <el-form-item
              label="设备编号："
              prop="equipmentCode"
            >
              <el-input
                v-model="dataForm.equipmentCode"
                placeholder="请输入设备编号"
                clearable
                maxlength="50"
                style="width:210px;"
              ></el-input>
            </el-form-item>
          </div>
          <div class="search-conent">
            <el-form-item
              label="设备名称："
              prop="equipmentName"
            >
              <el-input
                v-model="dataForm.equipmentName"
                placeholder="请输入设备名称"
                clearable
                maxlength="50"
                style="width:210px;"
              ></el-input>
            </el-form-item>
          </div>
          <div class="search-but">
            <el-button
              class="s2b-button"
              @click="getDataList()"
            >查询</el-button>
          </div>
        </div>
        <div class="search-row">
          <div class="search-conent">
            <el-form-item
              label="设备类别："
              prop="equipmentType"
            >
              <el-input
                v-model="dataForm.equipmentType"
                placeholder="请输入设备类别"
                clearable
                style="width:210px;"
              ></el-input>
            </el-form-item>
          </div>
          <div class="search-conent">
            <el-form-item
              label="设备状态："
              prop="equipmentStatus"
            >
              <el-select
                v-model="dataForm.equipmentStatus"
                placeholder="请选择"
                style="width:210px;"
                clearable
              >
                <el-option
                  value="0"
                  key="0"
                  label="正常"
                ></el-option>
                <el-option
                  value="1"
                  key="1"
                  label="维修"
                ></el-option>
                <el-option
                  value="2"
                  label="闲置"
                  key="2"
                ></el-option>
                <el-option
                  value="3"
                  label="报废"
                  key="3"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="search-but">
            <el-button
              class="s2b-button"
              @click="reset()"
            >重置</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 操作按钮 -->
    <div class="opt-row">
      <div class="opt-left">
        <el-button
          type="primary"
          @click="routerHandle('equipmentAddOrUpdate')"
          icon="el-icon-plus"
        >新增</el-button>
        <el-button
          class="s2b-button"
          @click="imp()"
        >批量导入</el-button>
        <el-button
          class="s2b-button"
          @click="exportData()"
        >批量导出</el-button>
        <el-button
          class="s2b-button"
          @click="deleteHandle()"
        >批量删除</el-button>
        <!-- <input type="file" class="info-but but-file" ref="inputer" v-show="false"
        @change="importf()" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/> -->
        <el-upload
          v-show="false"
          ref="fielUplod"
          :on-success="fileSuccess"
          :on-error="fileError"
          accept="csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :headers="headerMsg"
          :action="upLoadUrl"
        >
          <el-button type="primary">上传图片</el-button>
        </el-upload>
      </div>
      <div class="opt-right">
        <el-button
          class="s2b-button"
          @click="modelDownLoad()"
        >模板下载</el-button>
        <el-button
          class="s2b-button"
          @click="initList()"
        >初始化</el-button>
      </div>
    </div>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
    >
      <template slot="empty">
        <img src="@/assets/img/good/noGood.png">
        <div>暂无数据</div>
      </template>
      <el-table-column
        type="selection"
        width="40"
      ></el-table-column>
      <el-table-column
        type="index"
        header-align="center"
        align="center"
        width="40"
      ></el-table-column>
      <el-table-column
        prop="equipmentCode"
        header-align="center"
        align="center"
        label="设备编号"
      ></el-table-column>
      <el-table-column
        prop="equipmentName"
        header-align="center"
        align="center"
        label="设备名称"
        width="100px"
      >
        <template slot-scope="scope">
          <el-tooltip placement="bottom">
            <div
              slot="content"
              class="tip"
            >{{scope.row.equipmentName}}</div>
            <div class="demand-desc overell">{{scope.row.equipmentName}}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="equipmentType"
        header-align="center"
        align="center"
        label="设备类别"
      >
        <template slot-scope="scope">
          <el-tooltip placement="bottom">
            <div
              slot="content"
              class="tip"
            >{{scope.row.equipmentType}}</div>
            <div class="demand-desc overell">{{scope.row.equipmentType}}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        label="录入时间"
      ></el-table-column>
      <el-table-column
        prop="modifyUserName"
        header-align="center"
        align="center"
        label="最后修改人"
        width="100px"
      ></el-table-column>
      <el-table-column
        prop="nextOverhaulTime"
        header-align="center"
        align="center"
        label="检维修计划时间"
        :formatter="formatterDate"
      ></el-table-column>
      <el-table-column
        prop="equipmentStatus"
        header-align="center"
        align="center"
        label="设备状态"
        width="80"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.equipmentStatus==='0'">正常</span>
          <span v-else-if="scope.row.equipmentStatus==='1'">维修</span>
          <span v-else-if="scope.row.equipmentStatus==='2'">闲置</span>
          <span v-else-if="scope.row.equipmentStatus==='3'">报废</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="overhaulStatus"
        header-align="center"
        align="center"
        label="检维修状态"
        width="70"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.overhaulStatus==='0'">执行</span>
          <span v-else-if="scope.row.overhaulStatus==='1'">送审</span>
          <span v-else-if="scope.row.overhaulStatus==='2'">完成</span>
          <!-- <span>完成</span>
          <span>结束</span> -->
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="操作"
        width="70"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="routerHandle('equipmentDetail', {id:scope.row.id})"
          >详情</el-button>
          <el-tooltip
            class="item"
            effect="light"
            placement="right"
          >
            <div
              slot="content"
              class="tooltip-content"
              style="width:60px;text-align:center;border-color:#fff"
            >
              <el-button
                type="text"
                @click="routerHandle('equipmentAddOrUpdate', {id:scope.row.id})"
              >修改</el-button>
              <el-button
                type="text"
                @click="deleteHandle(scope.row)"
                style="margin: 0;"
              >删除</el-button>
              <!-- <el-button type="text">确认</el-button> -->
            </div>
            <i class="el-icon-arrow-down"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page.page"
      :page-size="page.limit"
      :total="total"
      class="s2b_page"
      prev-text="上一页"
      next-text="下一页"
      style="text-align: center;"
      layout="total, prev, pager, next, jumper"
      @current-change="getDataList"
    >
    </el-pagination>
    <el-dialog
      title="批量导入失败原由"
      :close-on-click-modal="false"
      :visible.sync="importVisible"
      width='530px'
    >
      <div v-html="errorContent"></div>
      <span slot="footer">
        <el-button @click="importVisible=false;errorContent=''">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { getAccessToken } from '@/utils/userInfo'
import axios from 'axios'
export default {
  name: 'equipmentList', // 设备列表
  components: {},
  // mixins: [],
  // props: {},
  data () {
    return {
      dataForm: {
        equipmentCode: '', // 设备编号
        equipmentName: '', // 设备名称
        equipmentType: '', // 设备类别
        equipmentStatus: '' // 设备状态
      },
      page: {
        page: 1,
        limit: 10
      },
      total: 0,
      dataListLoading: false,
      dataList: [], // 列表数据
      selectList: [], // 多选列表
      // 导入
      upLoadUrl: `${window.SITE_CONFIG['apiURL']}/front/sys/productequipment/pmequipment/importEquipments?companyId=${(this.$store.state.user.defaultCompanyId + '') || ''}`,
      headerMsg: {
        Authorization: 'Bearer ' + getAccessToken()
      },
      errorContent: '', // 导入失败消息
      importVisible: false // 导入失败dialog
    }
  },
  computed: {},
  // watch: {},
  mounted () {
    this.getDataList(1)
  },
  methods: {
    // 格式化日期
    formatterDate (row, column, value) {
      let result = ''
      let date = ''
      if (value) {
        date = new Date(value.replace(/ /g, 'T'))
      } else {
        date = new Date()
      }
      const month = date.getMonth() + 1
      const strDate = date.getDate()
      result = date.getFullYear() + '-' + (month >= 10 ? month : '0' + month) + '-' + (strDate >= 10 ? strDate : '0' + strDate)
      return result
    },
    // 重置
    reset () {
      Object.keys(this.dataForm).forEach((key) => {
        this.dataForm[key] = ''
      })
    },
    // 查询数据列表
    getDataList (page = this.page.page) {
      this.page.page = page
      this.dataListLoading = true
      this.$http
        .post(`/front/sys/productequipment/pmequipment/list`, {
          ...this.dataForm,
          ...this.page,
          companyId: (this.$store.state.user.defaultCompanyId + '') || ''
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.dataList = data.data.data || []
            this.total = Number(data.data.count) || 0
          } else {
            this.clear()
          }
        })
        .catch(() => {
          this.clear()
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    // 清空数据及分页等
    clear () {
      this.dataListLoading = false
      this.dataList = []
      this.page.page = 1
      this.total = 0
    },
    // 路由跳转
    routerHandle (routeName, query = {}) {
      this.$router.push({
        name: routeName,
        query
      })
    },
    // 批量导入input
    imp () {
      // this.$refs.inputer.click()
      this.$refs.fielUplod.$el.childNodes[0].childNodes[1].click()
    },
    // 导入成功
    fileSuccess (response, file, fileList) {
      if (response.code === 0) {
        this.$message.success(response.data || '导入成功')
        this.getDataList(1)
      } else {
        this.errorContent = response.message || '导入失败'
        this.importVisible = true
      }
    },
    // 导入失败err, file, fileList
    fileError (response) {
      this.$message.error('导入失败，请重新上传')
    },
    // 模板下载
    modelDownLoad () {
      window.location.href = `${window.SITE_CONFIG['apiURL']}/front/consumer/templatedownload/DeviceImportTemp`
    },
    // 导出
    exportData () {
      axios({
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getAccessToken()
        },
        responseType: 'blob', // 一定要写
        method: 'get',
        url: `${window.SITE_CONFIG.apiURL}/front/sys/productequipment/pmequipment/exportEquipments`,
        params: {
          ...this.dataForm,
          companyId: (this.$store.state.user.defaultCompanyId + '') || ''
        }
      })
        .then((res) => {
          if (res.data.size > 0) {
            // const that = this
            const reader = new FileReader()
            reader.onload = (e) => {
              // if (e.target.result.indexOf('"code":0') > -1) {
              const blob = new Blob([res.data], {
                type: 'application/vnd.ms-excel'
              })
              const date = new Date()
              const month = date.getMonth() + 1
              const day = date.getDate()
              const fileName =
                '用户台账信息' +
                date.getFullYear() +
                (month >= 10 ? month : '0' + month) +
                (day >= 10 ? day : '0' + day) // 下载的文件名
              if ('msSaveOrOpenBlob' in navigator) {
                // 'IE'
                window.navigator.msSaveOrOpenBlob(blob, fileName + '.xls')
              } else {
                const link = document.createElement('a')
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                link.download = res.headers['content-disposition'] // 下载后文件名
                link.download = fileName
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
              }
              // } else {
              //   const data = JSON.parse(e.target.result)
              //   if (data.code !== 0) {
              //     that.$message.error(data.message)
              //     return false
              //   }
              // }
            }
            reader.readAsText(res.data)
          }
        })
        .catch(() => {})
    },
    // 初始化数据
    initList () {
      this.$confirm(`确定对删除所有数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dataListLoading = true
        this.$http
          .delete(
            `/front/sys/productequipment/pmequipment/initializationData`
          )
          .then(({ data }) => {
            if (data && data.code === 0) {
              this.clear()
            }
          })
          .finally(() => {
            this.dataListLoading = false
          })
      })
    },
    // 多选
    selectionChangeHandle (list) {
      this.selectList = list
    },
    // 批量删除
    deleteHandle (row) {
      let ids = []
      if (row) {
        ids.push(row.id)
      } else {
        ids = this.selectList.map((item) => {
          return item.id
        })
      }
      if (ids.length === 0) {
        this.$message.error(this.$t('message.noDeleteData'))
        return false
      }
      this.$confirm(`确定对删除${ids.length}条数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dataListLoading = true
        this.$http
          .post(`/front/sys/productequipment/pmequipment/delete`, {
            ids: ids
          })
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message.success('删除成功')
              this.getDataList(1)
            } else {
              this.dataListLoading = false
            }
          })
          .catch(() => {
            this.dataListLoading = false
          })
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.equipment-list {
  .search-form {
    .search-row {
      display: flex;
      .search-conent {
        min-width: 310px;
        margin-right: 20px;
      }
      .search-but {
        width: 100%;
        min-width: 200px;
        text-align: right;
      }
    }
  }
  .opt-row {
    width: 100%;
    display: flex;
    text-align: right;
    margin-bottom: 20px;
    .opt-left {
      width: 100%;
      text-align: left;
    }
    .opt-right {
      width: 300px;
    }
    .info-but {
      background: #ffffff;
      width: 96px;
      height: 40px;
      text-align: center;
      line-height: 38px;
      font-size: 14px;
      color: #1d65a8;
      letter-spacing: 0;
      border: none;
      cursor: pointer;
      border: 1px solid #1d65a8;
      margin-right: 10px;
    }
  }
}
</style>
